<script setup lang="ts">
import { computed } from "vue";

import { useDictsysInflectionSchemeStore } from "@/stores";
import type { DictsysInflectionScheme, DictsysWordclass } from "@/types";

const props = defineProps<{
  language: string;
  headWord: string;
  wordclass: DictsysWordclass;
  inflectionScheme: DictsysInflectionScheme;
  schemeId: string;
}>();

const dictsysInflectionSchemeStore = useDictsysInflectionSchemeStore();
const { canShowInflectionScheme, getScheme, isSchemeOpen, toggleScheme } = dictsysInflectionSchemeStore;

const isOpen = computed<boolean>(
  () => isSchemeOpen(props.schemeId) && getScheme(props.schemeId).id === props.inflectionScheme.id
);

const toggle = () => toggleScheme(props.schemeId, props.headWord, props.wordclass, props.inflectionScheme);
</script>

<template>
  <template v-if="canShowInflectionScheme(props.language, props.wordclass, props.inflectionScheme)">
    <slot v-bind="{ isOpen, toggle }" />
  </template>
</template>
